import { render } from "./MainTab.vue?vue&type=template&id=28f1ef97&scoped=true"
import script from "./MainTab.vue?vue&type=script&lang=js"
export * from "./MainTab.vue?vue&type=script&lang=js"

import "./MainTab.vue?vue&type=style&index=0&id=28f1ef97&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f1ef97"]])

export default __exports__